import CookiePolicyPage from "pages/legal/CookiePolicyPage";
import React from "react";

const CookiePolicyRoute = () => <CookiePolicyPage />;

export default CookiePolicyRoute;
